var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11111 18.3897H3.61528L13.9333 7.15474L12.4292 5.51691L2.11111 16.7519V18.3897ZM0 20.6884V15.8036L13.9333 0.660879C14.1444 0.450164 14.3775 0.287339 14.6326 0.172403C14.8877 0.0574678 15.156 0 15.4375 0C15.719 0 15.9917 0.0574678 16.2556 0.172403C16.5194 0.287339 16.7481 0.459742 16.9417 0.689613L18.3931 2.29871C18.6042 2.50943 18.7581 2.75845 18.8549 3.04579C18.9516 3.33313 19 3.62047 19 3.90781C19 4.2143 18.9516 4.50643 18.8549 4.78419C18.7581 5.06195 18.6042 5.31577 18.3931 5.54564L4.48611 20.6884H0ZM13.1681 6.35019L12.4292 5.51691L13.9333 7.15474L13.1681 6.35019Z",
    fill: "#1F75A8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21.4551,
    width: 19,
    height: 1.93008,
    fill: "#1F75A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.64ccdc94619b106fe587dc01c6435d2d.svg";
export { ForwardRef as ReactComponent };